import React from "react";
import oliverLogo from "../../assetFiles/oliver_agency_logo.jpg"
import barnardLogo from "../../assetFiles/barnardLogo.png"
import outlierLogo from "../../assetFiles/outlierLogo.jpg"
import deweysmartLogo from "../../assetFiles/deweysmartLogo.jpg"
import columbiaLogo from "../../assetFiles/columbiaLogo.png"
import nailSupplyLogo from "../../assetFiles/nailSupply.png"
import linkedinLogo from "../../assetFiles/LI-Logo.png"
import gmailLogo from "../../assetFiles/gmailLogo.png"
import githubLogo from "../../assetFiles/GitHub_Logo.png"
import "./Experience.css"

function ExperiencePage() {
    return (
        <div style={{
        }}>
            <div className="experience-page">
                <div style={{
                    position: 'relative',
                    top: '30px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '95%',   
                    zIndex: 2,
                    transition: 'opacity 1s ease-in',
                }}>
                    <div style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        border: '2px solid #333',
                        borderRadius: '15px',
                        padding: '10px',
                        boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center'
                    }}>
                        <a href="/Home" style={{ color: 'white', textDecoration: 'none' }}>Home</a>
                        <a href="/Education" style={{ color: 'white', textDecoration: 'none' }}>Education</a>
                        <a href="/Experience" style={{ color: 'white', textDecoration: 'none' }}>Experience</a>
                        <a href="/Leadership" style={{ color: 'white', textDecoration: 'none' }}>Leadership</a>
                        <a href="/Projects" style={{ color: 'white', textDecoration: 'none' }}>Projects</a>
                        <a href="/Skills" style={{ color: 'white', textDecoration: 'none' }}>Skills</a>
                    </div>
                </div>
                <div>
                    <h1 style={{color: 'white', marginTop: '80px'}}>Experience</h1>
                </div>
                <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                    <div style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                                border: '2px solid #333',
                                borderRadius: '15px',
                                padding: '10px',
                                boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                                zIndex: 2,
                                width: '43rem',
                                height: 'fit-content',
                                marginBottom: '2rem',
                            }}>
                        <h2 style={{color: 'white'}}>Artifical Intelligence Product Intern</h2>
                        <h3 style={{color: 'white'}}>OLIVER Agency</h3>
                        <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                            <span>June 2024 - Present</span>
                            <span>New York, NY</span>
                        </div>
                        <div style={{margin: '20px 0px'}}>
                            <img style={{width: '200px', height: '200px', borderRadius: '15px', border: 'solid 1px white'}}src={oliverLogo} alt="OLIVER Logo"></img>
                        </div>
                        <div style={{display: 'flex', alignItems: 'flex-start'}}>
                            <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                    <li style={{marginBottom: '5px'}}>Develop proof-of-concepts, workflows, and prototypes leveraging AI technologies to address specific project management challenges, collaborating with project managers and other technical teams.</li>
                                    <li style={{marginBottom: '5px'}}>Create software and applications using React.js, Python, and Flask based on results from AI tools to expand AI credentials and use to a commercial market.</li>
                                    <li>Analyze data, create visualizations, and generate reports using AI-powered tools, and provide feedback and recommendations on the usability, limitations, and potential improvements of AI solutions.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                    <div style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                                border: '2px solid #333',
                                borderRadius: '15px',
                                padding: '10px',
                                boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                                zIndex: 2,
                                width: '43rem',
                                height: 'fit-content',
                                marginBottom: '2rem'
                            }}>
                        <h2 style={{color: 'white'}}>Full-Stack Developer</h2>
                        <h3 style={{color: 'white'}}>Barnard Gardening</h3>
                        <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                            <span>April 2023 - June 2024</span>
                            <span>New York, NY</span>
                        </div>
                        <div style={{margin: '20px 0px'}}>
                            <img style={{width: '500px', height: '75px', borderRadius: '15px', border: 'solid 1px white', backgroundColor:'white', padding: '10px', marginTop: '10px'}}src={barnardLogo} alt="Barnard Logo"></img>
                        </div>
                        <div style={{display: 'flex', alignItems: 'flex-start'}}>
                            <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                    <li style={{marginBottom: '5px'}}>Used React.js and Python to build a website that spreads and supports organization missions and values, gathering and placing user information when needed in a database.</li>
                                    <li style={{marginBottom: '5px'}}>Created clean user interface design using Figma.</li>
                                    <li>Utilized and maintained Agile methodologies to ensure smooth development process.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                    <div style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                                border: '2px solid #333',
                                borderRadius: '15px',
                                padding: '10px',
                                boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                                zIndex: 2,
                                width: '43rem',
                                height: 'fit-content',
                                marginBottom: '2rem'
                            }}>
                        <h2 style={{color: 'white'}}>Artifical Intelligence Model Performance Analyst (Freelance)</h2>
                        <h3 style={{color: 'white'}}>Outlier AI</h3>
                        <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                            <span>January 2024 - June 2024</span>
                            <span>Remote, NY</span>
                        </div>
                        <div style={{margin: '20px 0px'}}>
                            <img style={{width: '200px', height: '200px', borderRadius: '15px', border: 'solid 1px white'}}src={outlierLogo} alt="Outlier Logo"></img>
                        </div>
                        <div style={{display: 'flex', alignItems: 'flex-start'}}>
                            <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                    <li style={{marginBottom: '5px'}}>Curated and fed informative and factually correct responses to artificial intelligence, training four different models. </li>
                                    <li style={{marginBottom: '5px'}}>Flagged issues with validity of chatbot responses and knowledge, fixing over 50 incorrect outputs.</li>
                                    <li>Analyzed model data, generated reports using to provide feedback and recommendations on the usability, limitations, and potential improvements of four models.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                    <div style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                                border: '2px solid #333',
                                borderRadius: '15px',
                                padding: '10px',
                                boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                                zIndex: 2,
                                width: '43rem',
                                height: 'fit-content',
                                marginBottom: '2rem',
                            }}>
                        <h2 style={{color: 'white'}}>Product Manager (Project Contract)</h2>
                        <h3 style={{color: 'white'}}>DeweySmart Education</h3>
                        <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                            <span>February 2022 - July 2022</span>
                            <span>Remote, NY</span>
                        </div>
                        <div style={{margin: '20px 0px'}}>
                            <img style={{width: '200px', height: '200px', borderRadius: '15px', border: 'solid 1px white'}}src={deweysmartLogo} alt="DeweySmart Logo"></img>
                        </div>
                        <div style={{display: 'flex', alignItems: 'flex-start'}}>
                            <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                    <li style={{marginBottom: '5px'}}>Develop proof-of-concepts, workflows, and specifications for user-facing media education products using JIRA.</li>
                                    <li style={{marginBottom: '5px'}}>Analyzed data from media content pages and spearheaded three media projects to create tutoring resources, utilizing Agile methodologies.</li>
                                    <li style={{marginBottom: '5px'}}>Expanded the business on media platforms, including creating content and links for advertising.</li>
                                    <li style={{marginBottom: '5px'}}>Onboarded three team members and hosted meetings to gather development feedback and develop future steps.</li>
                                    <li>Led experimental video-based projects with teams, and kickstarted outreach to thousands of users across media platforms, resulting in over an 100% increase in followers.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                    <div style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                                border: '2px solid #333',
                                borderRadius: '15px',
                                padding: '10px',
                                boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                                zIndex: 2,
                                width: '43rem',
                                height: 'fit-content',
                                marginBottom: '2rem'
                            }}>
                        <h2 style={{color: 'white'}}>Research Assistant</h2>
                        <h3 style={{color: 'white'}}>Laboratory of Intergroup Relations and the Social Mind at Columbia University</h3>
                        <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                            <span>January 2019 - September 2021</span>
                            <span>New York, NY</span>
                        </div>
                        <div style={{margin: '20px 0px'}}>
                            <img style={{width: '200px', height: '200px', borderRadius: '15px', border: 'solid 1px white'}}src={columbiaLogo} alt="Columbia Logo"></img>
                        </div>
                        <div style={{display: 'flex', alignItems: 'flex-start'}}>
                            <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                    <li style={{marginBottom: '5px'}}>Prepared background research and analysis for three studies.</li>
                                    <li style={{marginBottom: '5px'}}>Performed and learned data analysis using R and R-Studio.</li>
                                    <li>Assisted in preparation for presentation for conferences, as well as payments and file-keeping for research projects.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{position: 'relative', left: '50%', transform: 'translateX(-50%)', width: '43rem'}}>
                    <div style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                                border: '2px solid #333',
                                borderRadius: '15px',
                                padding: '10px',
                                boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                                zIndex: 2,
                                width: '43rem',
                                height: 'fit-content',
                                marginBottom: '2rem',
                            }}>
                        <h2 style={{color: 'white'}}>General Manager</h2>
                        <h3 style={{color: 'white'}}>Wholesale Nail Supply</h3>
                        <div style={{justifyContent: 'space-between  ', color: 'white', display: 'flex'}}>
                            <span>January 2017 - September 2021</span>
                            <span>Queens, NY</span>
                        </div>
                        <div style={{margin: '20px 0px'}}>
                            <img style={{width: '200px', height: '200px', borderRadius: '15px', border: 'solid 1px white'}}src={nailSupplyLogo} alt="Nail Supply Logo"></img>
                        </div>
                        <div style={{display: 'flex', alignItems: 'flex-start'}}>
                            <div style={{color: 'white', display: 'flex', flexDirection:'column', alignItems: 'flex-start', margin: '5px 0'}}>
                                <ul style={{fontSize: '1em', textAlign: 'left'}}>
                                    <li style={{marginBottom: '5px'}}>Led a team focused on product sales through daily tasks, created timetables and schedules, and set up assigned responsibilities.</li>
                                    <li style={{marginBottom: '5px'}}>Managed sales and a point-of-sale system, resulting in a 68% increase in revenue.</li>
                                    <li style={{marginBottom: '5px'}}>Worked with marketing staff to promote content, leading to nearly triple the number of returning customers.</li>
                                    <li>Assigned teams to projects and monitored status of projects, and resolved team disputes.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{
                            position: 'relative',
                            bottom: '10px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: '95%',
                            zIndex: 2,
                        }}>
                        <div style={{
                                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                                border: '2px solid #333',
                                borderRadius: '15px',
                                padding: '10px',
                                boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                            <span style={{ color: 'white' }}>© 2024 Steven Huang | Product Manager & Developer | v1.2 | stevenhuangtech@gmail.com</span>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center'  // This ensures vertical centering of the buttons
                                }}>
                                <span style={{ color: 'white'}}>Interested? Feel free to contact me! ---{'>'} </span>
                                <a 
                                    href="mailto:stevenhuangtech@gmail.com" 
                                    style={{
                                    backgroundColor: 'white',
                                    border: 'none',
                                    padding: '5px',
                                    margin: '0 5px',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '20px',
                                    height: '20px',
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.opacity = 0.7}
                                    onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                    >
                                    <img 
                                        src={gmailLogo}
                                        alt="Email"
                                        style={{
                                            width: '20px',
                                            height: '20px'
                                        }}
                                    />
                                </a>
                                <a 
                                    href="https://github.com/huangs-nyc" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{
                                    backgroundColor: 'white',
                                    border: 'none',
                                    padding: '5px',
                                    margin: '0 5px',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '70px',
                                    height: '20px'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
                                    onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                    >
                                    <img 
                                        src={githubLogo} 
                                        alt="Github"
                                        style={{
                                        width: '50px',
                                        height: '20px'
                                        }}
                                    />
                                </a>
                                <a 
                                    href="https://www.linkedin.com/in/steven-huang-a60a8a22a/" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    style={{
                                    backgroundColor: 'white',
                                    border: 'none',
                                    padding: '5px',
                                    margin: '0 5px',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100px',
                                    height: '20px'
                                }}
                                    onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
                                    onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                >
                                <img 
                                    src={linkedinLogo} 
                                    alt="LinkedIn"
                                    style={{
                                    width: '80px',
                                    height: '20px'
                                    }}
                                />
                                </a>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    );
}

export default ExperiencePage